<template>
  <div id="app">
    <Indexadd  v-if="!showMap" @xgMap="hideMap"></Indexadd>
    <mapSearch v-if="showMap" :typeId="typeId"/>
  </div>
</template>

<script>
import Indexadd from './components/Indexadd.vue'
import mapSearch from './components/mapSearch.vue'

export default {
  name: 'App',
  components: {
    Indexadd,
    mapSearch
  },
  data() {
    return {
      showMap:false,
      typeId:''
    }
  },
  mounted() {},
  methods: {
    hideMap(e){
      console.log(e)
      if(e.type==1){//更多详情
        this.typeId=''
      }
      if(e.type==2){//筛选类型
        this.typeId=e.value
      }
      this.showMap=true
    }
  }
}
</script>

<style>
  *{margin: 0;padding: 0;box-sizing: border-box;}
  html,body,#app{
      width: 100%;
      height: 100%;
  }
</style>
